export const isImage = (fileName) => {
    return /\.(png|jpg|jpeg|gif|webp)$/.test(fileName);
}

export const isVideo = (fileName) => {
    return /\.(mp4|wmv|avi|mov|webp)$/.test(fileName);
}

export const isImageSrc = (src) => {
    return /\.(png|jpg|jpeg|gif|webp)$/.test(src);
}

export const getRandomNum = (min,max) => {
    const range = max - min;
    const rand = Math.random();
    return(min + Math.round(rand * range));
}
